/**
 * Role display name mapping
 * Maps Azure AD role names to user-friendly display names
 */

export enum UserRoleDisplay {
    Reader = 'Reader',
    Writer = 'Writer',
    ChemGuardWriter = 'ChemGuardWriter',
    Auditor = 'Auditor',
}

/**
 * Maps Azure AD role names to display names
 */
const roleDisplayMap: Record<string, UserRoleDisplay> = {
    OdfjellUser: UserRoleDisplay.Reader,
    CommodityBookEditor: UserRoleDisplay.Writer,
    CommodityBookChemGuardEditor: UserRoleDisplay.ChemGuardWriter,
    CommodityBookAuditor: UserRoleDisplay.Auditor,
};

/**
 * Gets the display name for a role
 * @param roleName The Azure AD role name
 * @returns The user-friendly display name, or the original role name if not mapped
 */
export const getRoleDisplayName = (roleName: string): string => {
    return roleDisplayMap[roleName] || roleName;
};

/**
 * Maps an array of Azure AD role names to their display names
 * @param roles Array of Azure AD role names
 * @returns Array of user-friendly display names
 */
export const mapRolesToDisplayNames = (roles: string[]): string[] => {
    return roles.map(getRoleDisplayName);
};

/**
 * Gets unique display names for roles (removes duplicates after mapping)
 * @param roles Array of Azure AD role names
 * @returns Array of unique user-friendly display names
 */
export const getUniqueRoleDisplayNames = (roles: string[]): string[] => {
    const displayNames = mapRolesToDisplayNames(roles);
    return [...new Set(displayNames)];
};
